import React from 'react';
import { Age, Code } from './LivePage';
import PagedWorkloadPage from './PagedWorkloadPage';

/**
 * ClusterRoles.
 *
 * The sidebar linked to /cluster-roles with no route and no component, so it hit the
 * path="*" catch-all and silently landed on the Dashboard. This is that page.
 */
export default function ClusterRoles() {
  return (
    <PagedWorkloadPage
      title="Cluster Roles" kind="ClusterRole" resource="clusterroles"
      label="cluster roles" detail={false} clusterScoped={true}
      cols={['Name', 'Rules', 'Verbs', 'Resources', 'Age']}
      renderRow={r => [
        <td key="n"><Code>{r.name}</Code></td>,
        <td key="rc">{r.rule_count}</td>,
        <td key="v" style={{ fontSize: 12, color: 'var(--muted)' }}>
          {(r.verbs || []).join(', ') || '—'}
        </td>,
        <td key="rs" style={{ fontSize: 12, color: 'var(--muted)' }}>
          {(r.resources || []).join(', ') || '—'}
        </td>,
        <td key="a"><Age ts={r.created_at} /></td>,
      ]}
    />
  );
}
